export const Roles = {
   SUPERADMIN: "SUPERADMIN",
   ADMIN: "ADMIN",
   MANAGER: "MANAGER",
   TAX_PROVIDER: "TAX_PROVIDER",
};

export const ACLSubject = {
   USER: "user",
   TAX_PROVIDER: "tax_provider",
   PUBLIC_ENTITY: "public_entity",
   REPORT: "report",
   NEWS: "news",
   EVENT: "event",
};

export const ResponseErrorType = {
   GRAPHQL_ERROR: 1,
   NETWORK_ERROR: 2,
};

export const ReportStatusType = {
   GEOCODING: "geocoding",
   GEOCODING_NOT_FOUND: "geocoding_not_found",
   GEOCODING_ERROR: "geocoding_error",
   PENDING: "pending",
   ASSIGNED: "assigned",
   IN_PROGRESS: "in_progress",
   RESOLVED: "resolved",
   REJECTED: "rejected",
};

export const ReportCategoryType = {
   AMBIENTE: "AMBIENTE",
   DEGRADO_URBANO: "DEGRADO_URBANO",
   PROTEZIONE_CIVILE: "PROTEZIONE_CIVILE",
};

export const ReportType = {
   // AMBIENTE
   RIFIUTI_URBANI: "RIFIUTI_URBANI",
   INGOMBRANTI: "INGOMBRANTI",
   PNEUMATICI: "PNEUMATICI",
   RAEE: "RAEE",
   RIFIUTI_PERICOLOSI: "RIFIUTI_PERICOLOSI",
   SFALCI_POTATURE: "SFALCI_POTATURE",
   VEICOLO_ABBANDONATO: "VEICOLO_ABBANDONATO",
   MATERIALI_EDILI: "MATERIALI_EDILI",
   AMIANTO: "AMIANTO",
   SVERSAMENTI: "SVERSAMENTI",
   ROGHI: "ROGHI",
   INQUINAMENTO_CORSI_ACQUA: "INQUINAMENTO_CORSI_ACQUA",
   // DEGRADO_URBANO
   SICUREZZA_URBANA: "SICUREZZA_URBANA",
   BUCHE: "BUCHE",
   DISSESTI_STRADALI: "DISSESTI_STRADALI",
   ILLUMINAZIONE_GUASTA: "ILLUMINAZIONE_GUASTA",
   SEGNALETICA_DANNEGGIATA: "SEGNALETICA_DANNEGGIATA",
   VERDE_TRASCURATO: "VERDE_TRASCURATO",
   ALLAGAMENTI_DRENAGGIO: "ALLAGAMENTI_DRENAGGIO",
   ALBERI_PERICOLANTI: "ALBERI_PERICOLANTI",
   // PROTEZIONE_CIVILE
   PERSONE_IN_PERICOLO: "PERSONE_IN_PERICOLO",
   STRADA_BLOCCATA: "STRADA_BLOCCATA",
   CROLLO_DANNO_STRUTTURALE: "CROLLO_DANNO_STRUTTURALE",
   RISCHIO_ELETTRICO_PC: "RISCHIO_ELETTRICO_PC",
   INCENDIO_FUMO: "INCENDIO_FUMO",
   EVENTO_NATURALE_GRAVE: "EVENTO_NATURALE_GRAVE",
   // Catch-all
   NON_DEFINITO: "NON_DEFINITO",
};

export const ReportSeverityType = {
   PICCOLO: "PICCOLO",
   MEDIO: "MEDIO",
   GRANDE: "GRANDE",
   PERICOLOSO: "PERICOLOSO",
   NON_DEFINITO: "NON_DEFINITO",
};

export const ReportRiskType = {
   // AMBIENTE
   LIQUIDI: "LIQUIDI",
   VICINANZA_ABITAZIONI: "VICINANZA_ABITAZIONI",
   ANIMALI: "ANIMALI",
   ODORI_FORTI: "ODORI_FORTI",
   ZONA_VENTOSA: "ZONA_VENTOSA",
   RISCHIO_AMBIENTALE: "RISCHIO_AMBIENTALE",
   RISCHIO_INCENDIO: "RISCHIO_INCENDIO",
   // DEGRADO_URBANO
   PERICOLO_PERSONE: "PERICOLO_PERSONE",
   PERICOLO_VIABILITA: "PERICOLO_VIABILITA",
   PERICOLO_PEDONI: "PERICOLO_PEDONI",
   SCARSA_VISIBILITA: "SCARSA_VISIBILITA",
   PEGGIORAMENTO: "PEGGIORAMENTO",
   RISCHIO_CADUTA_CROLLO: "RISCHIO_CADUTA_CROLLO",
   // PROTEZIONE_CIVILE (PERICOLO_PERSONE already in DEGRADO_URBANO)
   RICHIEDE_INTERVENTO: "RICHIEDE_INTERVENTO",
   STRADA_TOTALMENTE_BLOCCATA: "STRADA_TOTALMENTE_BLOCCATA",
   RISCHIO_CROLLO_CEDIMENTO: "RISCHIO_CROLLO_CEDIMENTO",
   RISCHIO_ELETTRICO_PC: "RISCHIO_ELETTRICO_PC",
   RISCHIO_INCENDIO_ESPLOSIONE: "RISCHIO_INCENDIO_ESPLOSIONE",
   COINVOLGE_ABITAZIONI: "COINVOLGE_ABITAZIONI",
   // Catch-all
   NESSUN_RISCHIO: "NESSUN_RISCHIO",
};

export const ReportStatoPersonaType = {
   STO_BENE: "STO_BENE",
   BISOGNO_ASSISTENZA: "BISOGNO_ASSISTENZA",
   AIUTO_URGENTE: "AIUTO_URGENTE",
};

export const EventStatusType = {
   DRAFT: "DRAFT",
   APPROVED: "APPROVED",
   REJECTED: "REJECTED",
};
